export default "__VITE_ASSET__50tDj3WP__"